<template>
  <div class="main mainIndicateur2 mainIndicateur34">
      <div class="ind2-section ind-sectionSpe sectionCI0">
        <h2 :class="['h2Ind2', defileCi == 1 ? 'vueActiveI' : 'vueNoneI']">Avez-vous des douleurs</h2>

          <div :class="['ind2-bloc2','vueActiveI2', defileCi == 1 ? 'vueActiveI' : 'vueNoneI', 'vueA1']">
          <div class="bloc-douleur3">
            <h4>Vos douleurs ont-elles des répercussions sur votre travail de façon : </h4>
            <ul class="douleur3">
              <li>
                <button  :class="[{selected: douleur.repercutionTravail === 3}]" @click.prevent="sauvegardePlus('RT', 3)">
                  <p>Très Importante</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.repercutionTravail === 2}]" @click.prevent="sauvegardePlus('RT', 2)">
                  <p>Importante</p>
                </button>
              </li>
              <li>
                <button  :class="[{selected: douleur.repercutionTravail === 1}]" @click.prevent="sauvegardePlus('RT', 1)">
                  <p>Peu Importante</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.repercutionTravail === 0}]" @click.prevent="sauvegardePlus('RT', 0)">
                  <p>Insignifiante</p>
                </button>
              </li>
            </ul>
          </div>
          <!--
          <div class="gestionnaireBouton">
            <button  @click.prevent="sauvegardePlus()"  class="boutonInfo"><i  class="fa fa-angle-right"></i></button>
          </div>-->
        </div>
    <div :class="['ind2-bloc3', defileCi == 2 ? 'vueActiveI' : 'vueNoneI']">
          <div class="bloc-douleur4">
            <h4>Vos douleurs ont-elles des répercussions en dehors du travail de façon :</h4>
            <ul class="douleur4">
              <li>
                <button  :class="[{selected: douleur.repercutionMaison === 3}]" @click.prevent="sauvegardePlus('RM', 3)">
                  <p>Très Importante</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.repercutionMaison === 2}]" @click.prevent="sauvegardePlus('RM', 2)">
                  <p>Importante</p>
                </button>
              </li>
              <li>
                <button  :class="[{selected: douleur.repercutionMaison === 1}]" @click.prevent="sauvegardePlus('RM', 1)">
                  <p>Peu Importante</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.repercutionMaison === 0}]" @click.prevent="sauvegardePlus('RM', 0)">
                  <p>Insignifiante</p>
                </button>
              </li>
            </ul>
          </div>
          <!--<div class="gestionnaireBouton">
            <button   @click.prevent="sauvegardeMoins()"  class="boutonInfo"><i  class="fa fa-angle-left" ></i></button>
            <button  @click.prevent="sauvegardePlus()"  class="boutonInfo"><i  class="fa fa-angle-right"></i></button>
          </div>-->
    </div>
    <div :class="['ind2-bloc4', defileCi == 3 ? 'vueActiveI' : 'vueNoneI']">
      <div class="bloc-douleur5">
      <h4 class="douleur5">Intensité de vos douleurs :</h4>
      
        <input type="range" :value="douleur.intensite" name="cowbell" min="1" max="10" step="1" list="echelle" id="douleurEchelle"/>
        <datalist id="echelle" v-if="detectS == true">
          <select>
          <option value="1" >1</option>
          <option value="2"  class="dataListStyle">2</option>
          <option value="3"  class="dataListStyle">3</option>
          <option value="4"  class="dataListStyle">4</option>
          <option value="5"  class="dataListStyle">5</option>
          <option value="6"  class="dataListStyle">6</option>
          <option value="7"  class="dataListStyle">7</option>
          <option value="8"  class="dataListStyle">8</option>
          <option value="9"  class="dataListStyle">9</option>
          <option value="10"   class="dataListStyle">10</option>
        </select>
        </datalist>
        <datalist id="echelle" v-else>
          <option value="1" label="1"></option>
          <option value="2" label="2" class="dataListStyle"></option>
          <option value="3" label="3" class="dataListStyle"></option>
          <option value="4" label="4" class="dataListStyle"></option>
          <option value="5" label="5" class="dataListStyle"></option>
          <option value="6" label="6" class="dataListStyle"></option>
          <option value="7" label="7" class="dataListStyle"></option>
          <option value="8" label="8" class="dataListStyle"></option>
          <option value="9" label="9" class="dataListStyle"></option>
          <option value="10"  label="10" class="dataListStyle"></option>
        </datalist>
<!--
        <ul class="fakeRange">
          <li v-for="koko in arrayV" :key="koko" v-on:click="activetab = koko" :id="koko" v-bind:class="[ activetab === koko ? 'active' : '', activetab > koko ? 'passed' : '', 'fakeOption', koko == 0 ? 'first' : '', koko == 10 ? 'last' : '']" >
            <p>{{koko}}</p>
          </li>
        </ul>-->
      </div>
      <!--<div class="gestionnaireBouton">
        <button   @click.prevent="sauvegardeMoins()"  class="boutonInfo"><i  class="fa fa-angle-left" ></i></button>
      </div>-->
    </div>
  </div>
  </div>
</template>


<script>
import * as controle from "@/controller/correctionEcran.js";


export default {
  name: "Indicateur_2",
  data() {
    return {
      user: JSON.parse(localStorage.user)|| [],
      douleur: {
        travail: false,
        maison: false,
        repercutionTravail: null,
        repercutionMaison: null,
        intensite: 5,
      },
      tableau_profession: [{
        id:1,
        name:'soudeur'
        },{
          id:2,name:'chaudronier'
      }],
      arrayV: [],
      activetab: 5,
      defileCi: 1,
      detectS: false,
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined){
      this.user = JSON.parse(localStorage.user);
      this.indicateur = this.user.cI;
      if (this.indicateur !== null){
       this.indicateur = this.indicateur[3]; 
      
      console.log(this.indicateur);
      /*
      for (let i = 0;i < Object.size(this.indicateur.resultat); i++) {
        if (i == 1){
          if(this.indicateur.resultat[2] == "Très Importante"){
            this.douleur.repercutionTravail = 3;
          }else if(this.indicateur.resultat[2] == "Importante"){
            this.douleur.repercutionTravail = 2;
          }else if(this.indicateur.resultat[2] == "Peu Importante"){
            this.douleur.repercutionTravail = 1;
          }else{
            this.douleur.repercutionTravail = 0;
          } 
        }
        if (i == 2){
          if(this.indicateur.resultat[3] == "Très Importante"){
            this.douleur.repercutionMaison = 3;
          }else if(this.indicateur.resultat[3] == "Importante"){
            this.douleur.repercutionMaison = 2;
          }else if(this.indicateur.resultat[3] == "Peu Importante"){
            this.douleur.repercutionMaison = 1;
          }else{
            this.douleur.repercutionMaison = 0;
          } 
        }
        if (i == 3){
          this.intensite = Number(this.indicateur.resultat[4]); 
      }
      }*/
      if(Object.size(this.arrayV) == 0){
        for (let i = this.min; i < this.max +1; i++) {
        this.arrayV.push(i);
      }
      }
      
     // console.log(this.arrayV, this.intensite);
      //console.log(this.indicateur.resultat);
    }
    }

  },
  methods: {
    sexDefine (sexe){
      if (sexe === 0) {
        this.user.sexe = 'femme'
        //console.log(this.user.sexe)
        
      }else{
        this.user.sexe = 'homme'
        //console.log(this.user.sexe)
        //console.log(this.user.profession)       
      }
    },
    ageDefine (age){
      if (age === 'A'){
        this.user.age = '-19'
        //console.log(this.user.age + ' ans')
      }else if (age === 'B'){
        this.user.age = '20-30'
        //console.log(this.user.age + ' ans')
      }else if (age === 'C'){
        this.user.age = '30-40'
        //console.log(this.user.age + ' ans')
      }else if (age === 'D'){
        this.user.age = '40-50'
        //console.log(this.user.age + ' ans')
      }else{
        this.user.age = '+60'
        //console.log(this.user.age + ' ans')
      }
    },
    addMesure (att){
      if (att === 'poids'){
        this.user.poids++
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille++
        //console.log(this.user.taille + ' cm')
      }
    },
    lessMesure (att){
      if (att === 'poids'){
        this.user.poids--
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille--
        //console.log(this.user.taille + ' cm')
      }     
    },
    sauvegardePlus(r=null, rr=null){
      if (r == 'RT' && rr !== null){
        this.douleur.repercutionTravail = rr;
      }else if(r == 'RM' && rr !== null){
        this.douleur.repercutionMaison = rr;
      }
      if (this.defileCi !== 3){
       var corps = document.getElementsByClassName('selected');
      
        if (this.defileCi == 1){
          var array = [];
          array.push({'repercutionTravail': rr});
        }else{
          var array = JSON.parse(localStorage.indicateur3);
          array.push({'repercutionMaison': rr});
        }
        /*
        console.log(this.defileCi);
        Object.keys(corps).forEach(function (element, index) {
          console.log('ok12');
          array.push(corps[element].textContent);
        }); 
        */
      }else{
        //var echelle = document.getElementById('douleurEchelle').value;
        //array.push(echelle);
        console.log(this.defileCi);
        
      }
      console.log(array);
      localStorage.indicateur3 = JSON.stringify(array);
      
      console.log(localStorage.indicateur3);
      this.defileCi++;
      if (this.defileCi === 3){
        this.$emit('goValider');
      }
    },/*
      sauvegardePlus(){
      
      if (this.defileCi !== 4){
       var corps = document.getElementsByClassName('selected');
      
        if (this.defileCi == 1){
          var array = [];
        }else{
          var array = JSON.parse(localStorage.indicateur2);
        }
        
        Object.keys(corps).forEach(function (element, index) {
          array.push(corps[element].textContent);
        }); 
      }else{
        var echelle = document.getElementById('douleurEchelle').value;
        array.push(echelle);
      }
      localStorage.indicateur2 = JSON.stringify(array);
      //console.log(localStorage.indicateur2);
      this.defileCi++;
    },
    sauvegardeMoins(){
      if (this.defileCi > 1 && this.defileCi < 5){
        let array = JSON.parse(localStorage.indicateur2);
        array.pop();
        localStorage.indicateur2 = JSON.stringify(array);
      }
      this.defileCi--;
    },*/
  },
  mounted() {
    this.detectS = controle.detectSafari();
  },
  computed: {
    ideal (){
      return this.user.poids = this.user.taille -100 - ((this.user.taille - 150)/4);
    }
  }
};
</script>
  

<style>
.ind-sectionSpe{
  position: relative;
}
.vueActiveI {
  position: absolute !important;
  top: 20px !important;
  visibility: visible;
  opacity: 1 !important;
  transform: translateX(0px) !important;
  transition: visibility 2s, opacity 0.8s, transform 1.5s linear !important;
}
.vueActiveI2 {
  top: 80px !important;
}
.vueNoneI {
  position: absolute !important;
  top: 20px !important;
  visibility: hidden;
  opacity: 0 !important;
  transform: translateX(+30px) !important;
  transition: visibility 2s, opacity 0.8s, transform 1.5s linear !important;
}
.vueA1{
  top: 35px !important;
}
.mainIndicateur34{
    background-color: rgba(255, 255, 255, 0.7);
   border-radius: 8px 8px 8px 8px;
   padding-bottom: 20px;
   top: 10px;
   height: 55vh;
}

</style>


// WEBPACK FOOTER //
// src/components/indicateur/Indicateur_3.vue